import { ListItemButton } from '@mui/material'
import { ReactNode } from 'react'
import { matchPath, useLocation, useNavigate } from 'react-router-dom'

export type ListItemButtonWithNavigationProps = {
  path: string
  children: ReactNode
}

const ListItemButtonWithNavigation = ({ path, children }: ListItemButtonWithNavigationProps) => {
  const navigate = useNavigate()
  const location = useLocation()

  const isActive = matchPath(
    {
      path,
      end: false,
    },
    location.pathname
  )

  return (
    <ListItemButton
      href={path}
      onClick={(event) => {
        event.preventDefault()
        navigate(path)
      }}
      selected={!!isActive}
    >
      {children}
    </ListItemButton>
  )
}

export default ListItemButtonWithNavigation
